import {
  AnalyzeSettingsType,
  MeteringType,
  AnalyzeCompareWith,
  DatePeriodType,
  DateIntervalType,
  AnalyzeEconomyDisplayType
} from '@enums';
import dayjs from 'dayjs';

export class AnalyzePaneSettings {
  meteringType: MeteringType;
  settingsType: AnalyzeSettingsType;

  period: DatePeriodType;
  meteringPointIds?: number[];
  masterMeteringPointId?: number;
  monthDateFrom?: Date;
  monthDateTo?: Date;
  dayDateFrom: Date;
  dayDateTo: Date;
  hourDateFrom: Date;
  hourDateTo: Date;
  showTable: boolean;
  markDateFrom: Date;
  markDateTo: Date;
  monthInterval: DateIntervalType;
  dayInterval: DateIntervalType;
  hourInterval: DateIntervalType;

  compareYears?: number[];
  compareWith?: AnalyzeCompareWith;
  normalYearAdjustment?: boolean;
  excludeWeekends?: boolean;
  effctSignatureLine: boolean;
  displayPerMeteringPoint?: boolean;
  displayPerStatus?: boolean;
  displayCategoryEnergy?: boolean;
  displayCategoryEffect?: boolean;
  displayCategoryBonus?: boolean;
  displayCategoryServices?: boolean;
  displayCategoryOther?: boolean;
  displayCategorySpike?: boolean;
  explicitMeteringPointId?: number;
  displaySupplyTemp: boolean;
  displayTempBonus: boolean;
  displayNormalAdjusted: boolean;
  economyDisplayType: AnalyzeEconomyDisplayType;

  public static initalState(meteringType: MeteringType, settingsType: AnalyzeSettingsType) {
    let period = DatePeriodType.Month;
    let compareWith = AnalyzeCompareWith.Nothing;
    let economyDisplayType = AnalyzeEconomyDisplayType.Sum;

    let monthDateFrom = dayjs()
      .startOf('year')
      .toDate();
    let monthDateTo = dayjs()
      .endOf('year')
      .toDate();

    let dayDateFrom = dayjs()
      .subtract(31, 'days')
      .toDate();
    let dayDateTo = dayjs()
      .subtract(1, 'days')
      .toDate();

    let hourDateFrom = dayjs()
      .subtract(7, 'd')
      .startOf('day')
      .toDate();
    let hourDateTo = dayjs()
      .subtract(1, 'days')
      .startOf('day')
      .toDate();

    // Temperature, Month + 12 month, default is Month + ThisYear
    // if (settingsType === AnalyzeSettingsType.Temp) {
    //   monthDateFrom = dayjs()
    //     .startOf('month')
    //     .subtract(12, 'months')
    //     .toDate();

    //   monthDateTo = dayjs()
    //     .endOf('month')
    //     .subtract(1, 'months')
    //     .toDate();
    // }

    if (settingsType === AnalyzeSettingsType.Effect) {
      /*
      dayDateFrom = dayjs()
        .startOf('month')
        .subtract(12, 'months')
        .toDate();

      dayDateTo = dayjs()
        .subtract(1, 'months')
        .endOf('month')
        .toDate();
      */
       dayDateFrom = dayjs()
        .subtract(12, 'months')
        .subtract(1, 'days')
        .toDate();
      dayDateTo = dayjs()
        .subtract(1, 'days')
        .startOf('day')
        .toDate();

      hourDateFrom = dayjs()
        .subtract(31, 'd')
        .startOf('day')
        .toDate();
      hourDateTo = dayjs()
        .subtract(1, 'days')
        .startOf('day')
        .toDate();
      period = DatePeriodType.Day;
      compareWith = AnalyzeCompareWith.OutdoorTemp;
    }

    return {
      meteringPointIds: [],
      meteringType: meteringType,
      settingsType: settingsType,
      period: period,
      monthDateFrom: monthDateFrom,
      monthDateTo: monthDateTo,
      dayDateFrom: dayDateFrom,
      dayDateTo: dayDateTo,
      hourDateFrom: hourDateFrom,
      hourDateTo: hourDateTo,
      compareYears: [],
      compareWith: compareWith,
      economyDisplayType: economyDisplayType,
      normalYearAdjustment: false,
      excludeWeekends: false,
      effctSignatureLine: false,
      displayPerMeteringPoint: false,
      displayPerStatus: false,
      displayCategoryEnergy: true,
      displayCategoryEffect: true,
      displayCategoryBonus: true,
      displayCategoryServices: true,
      displayCategoryOther: true,
      displayCategorySpike: true,
      showTable: settingsType === AnalyzeSettingsType.Temp,
      explicitMeteringPointId: null,
      displaySupplyTemp: false,
      displayTempBonus: false,
      displayNormalAdjusted: false,
      monthInterval: settingsType === AnalyzeSettingsType.Effect ? DateIntervalType.TwelveMonths : DateIntervalType.ThisYear,
      dayInterval: settingsType === AnalyzeSettingsType.Effect ? DateIntervalType.TwelveMonths : DateIntervalType.OneMonth,
      hourInterval: settingsType === AnalyzeSettingsType.Effect ? DateIntervalType.OneMonth : DateIntervalType.OneWeek
    } as AnalyzePaneSettings;
  }
}
